import ModalShare from 'ui/components/atoms/ModalShare';
import Whatsapp from 'ui/components/atoms/Icons/Whatsapp';
import FacebookIcon from 'ui/components/atoms/Icons/FacebookIcon';
import Xlogo from 'ui/components/atoms/Icons/Xlogo';
import InstagramIcon from 'ui/components/atoms/Icons/InstagramIcon';
import TiktokIcon from '../../atoms/Icons/TiktokIcon';
import { PiLinkSimpleBold } from 'react-icons/pi';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useRef, useState } from 'react';
import eventClickShare from 'ui/lib/gtm/eventClickShare';
import useIsNativeView from '../../../hooks/useIsNativeView';
import { triggerNativeMessage } from '../../../helpers/utils';
import { IRootState } from '../../../store';
import { promoButtonClickOption } from '../../../helpers/emarsys/promo/eventClickPromo';
import useImpressionPromo from '../../../hooks/emarsys/promo/useImpressionPromo';
import useImpressionCouponService from '../../../hooks/emarsys/coupon-service/useImpressionCouponService';
import eventClickCouponService from '../../../helpers/emarsys/coupon-service/eventClickCouponService';
import useImpressionPackageService from '../../../hooks/emarsys/package-service/useImpressionPackageService';
import eventClickPackageService from '../../../helpers/emarsys/package-service/eventClickPackageService';
import useImpressionAccessories from '../../../hooks/emarsys/accessories/useImpressionAccessories';
import eventClickAccessories from '../../../helpers/emarsys/accessories/eventClickAccessories';
import useImpressionProductKnowledgeDetail from '../../../hooks/emarsys/product-knowledge/useImpressionProductKnowledgeDetail';
import eventClickProductKnowledgeDetail from '../../../helpers/emarsys/product-knowledge/eventClickProductKnowledgeDetail';
import useImpressionNewsDetail from 'ui/hooks/emarsys/news/useImpressionNewsDetail';
import eventClickNewsDetail from 'ui/helpers/emarsys/news/eventClickNewsDetail';

const socialLinks = ['whatsapp', 'facebook', 'x', 'tiktok', 'instagram'];

const SocialMediaLinksSection = ({
  article,
  copyLink,
  enableSharing = false,
  sectionClassName = '',
  screenSizeData = { screenSize: { height: 673, mobile: false, width: 1920 } },
  isServiceDetail = false,
  actionClick,
  impressionData = {
    pageTitle: '',
    breadCrumb: [],
    promo: {},
    sku: '',
    skuPrice: '',
    carModel: [],
    publishedDate: '',
  },
  feature = '',
}: any) => {
  const impressionRef = useRef(null);
  const dispatch = useDispatch();
  const [shareOpen, setShareOpen] = useState(false);
  const { screenSize } = enableSharing
    ? screenSizeData
    : useSelector((state: IRootState) => state.page);
  const [contentUrl, setContentUrl] = useState('');

  const isNativeView = useIsNativeView();

  const { isMobileScreen } = useSelector((state: IRootState) => state.page);

  // Exclude instagram if it's not native view
  const filteredSocialLinks = useMemo(
    () => socialLinks.filter((link) => (isNativeView ? link : link !== 'instagram')),
    [isNativeView]
  );

  // Get the current URL on the client side
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setContentUrl(window.location.href);
    }
  }, []);

  // Trigger share system on mobile
  const handleShare = async (e) => {
    actionClickEmarsys(promoButtonClickOption.shareCopylink);
    if (screenSize.mobile && navigator.share) {
      try {
        await navigator.share({
          title: article?.titlePage || '',
          text: 'Check out this article!',
          url: window.location.href,
        });
      } catch (error) {
        console.error('Share error:', error);
      }
    } else {
      if (isNativeView) {
        e.preventDefault();
        triggerNativeMessage('goToCopyClipboard');
      }

      if (!isNativeView) {
        setShareOpen(true);
      }
    }
  };

  const socialMediaShare = (platform) => {
    switch (platform) {
      case 'tiktok':
        return 'https://www.tiktok.com/@auto2000official';
      case 'whatsapp':
        return `https://api.whatsapp.com/send?text=${encodeURIComponent(
          (article?.titlePage || '') + ' ' + contentUrl
        )}`;
      case 'facebook':
        return `https://www.facebook.com/share.php?u=${encodeURIComponent(contentUrl)}`;
      case 'x':
        return `https://x.com/intent/tweet?url=${encodeURIComponent(
          contentUrl
        )}&text=${encodeURIComponent(article?.titlePage || '')}`;
      default:
        return '';
    }
  };

  const handleNativeShare = (platform) => {
    if (typeof window !== 'undefined') {
      switch (platform) {
        case 'whatsapp':
          (window as any)?.androidApp?.goToWhatsapp();
          (window as any)?.webkit?.messageHandlers?.iosApp?.postMessage?.('goToWhatsapp');
          break;
        case 'facebook':
          (window as any)?.androidApp?.goToFacebook();
          (window as any)?.webkit?.messageHandlers?.iosApp?.postMessage?.('goToFacebook');
          break;
        case 'x':
          (window as any)?.androidApp?.goToTwitter();
          (window as any)?.webkit?.messageHandlers?.iosApp?.postMessage?.('goToTwitter');
          break;
        case 'instagram':
          (window as any)?.androidApp?.goToInstagram();
          (window as any)?.webkit?.messageHandlers?.iosApp?.postMessage?.('goToInstagram');
          break;
        case 'tiktok':
          (window as any)?.androidApp?.goToTiktok();
          (window as any)?.webkit?.messageHandlers?.iosApp?.postMessage?.('goToTiktok');
          break;
        default:
          break;
      }
    }
  };

  const { categoryService } = useSelector((state: any) => state.dataGTM || {});
  const { userData } = useSelector((state: IRootState) => state.auth) || {
    userData: null,
  };
  const { selectedCar, selectedPackage } = useSelector((state: any) => state.servicePackage) || {
    selectedCar: null,
    selectedPackage: null,
  };

  const handleClickShare = (copyLink, platform) => {
    handleNativeShare(platform);
    eventClickShare(copyLink, platform, categoryService);
  };

  if (feature === 'PROMO') {
    useImpressionPromo(impressionRef, impressionData.promo, impressionData.breadCrumb, 'bagikan');
  } else if (feature === 'COUPON_SERVICE') {
    useImpressionCouponService(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadCrumb,
      'bagikan'
    );
  } else if (feature === 'PACKAGE_SERVICE') {
    useImpressionPackageService(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadCrumb,
      'bagikan'
    );
  } else if (feature === 'ACCESSORIES') {
    useImpressionAccessories(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadCrumb,
      impressionData.sku,
      impressionData.skuPrice,
      'bagikan',
      impressionData.carModel
    );
  } else if (feature === 'PRODUCT_KNOWLEDGE_DETAIL') {
    useImpressionProductKnowledgeDetail(
      impressionRef,
      impressionData.titlePage,
      impressionData.breadCrumb,
      impressionData.publishedDate,
      'bagikan'
    );
  } else if (feature === 'NEWS_DETAIL') {
    useImpressionNewsDetail(impressionRef, article, impressionData.breadCrumb, 'bagikan');
  }

  const actionClickEmarsys = (buttonName: string) => {
    if (feature === 'PROMO') {
      actionClick(buttonName);
    } else if (feature === 'COUPON_SERVICE') {
      eventClickCouponService(
        dispatch,
        selectedPackage,
        selectedCar,
        impressionData.pageTitle,
        impressionData.breadCrumb,
        userData?.customerNo,
        'bagikan',
        buttonName
      );
    } else if (feature === 'PACKAGE_SERVICE') {
      eventClickPackageService(
        dispatch,
        selectedPackage,
        selectedCar,
        impressionData.pageTitle,
        impressionData.breadCrumb,
        userData?.customerNo,
        'bagikan',
        buttonName
      );
    } else if (feature === 'ACCESSORIES') {
      eventClickAccessories(
        dispatch,
        impressionData.sku,
        impressionData.skuPrice,
        impressionData.pageTitle,
        impressionData.breadCrumb,
        userData?.customerNo,
        'bagikan',
        buttonName,
        impressionData.carModel
      );
    } else if (feature === 'PRODUCT_KNOWLEDGE_DETAIL') {
      eventClickProductKnowledgeDetail(
        impressionData.titlePage,
        impressionData.breadCrumb,
        impressionData.publishedDate,
        'bagikan',
        buttonName
      );
    } else if (feature === 'NEWS_DETAIL') {
      eventClickNewsDetail(article, impressionData?.breadCrumb, buttonName, 'bagikan');
    }
  };

  return (
    <section
      className={`flex items-center justify-center gap-10 mt-8 px-4 py-[18px] bg-reliableBlack3 lg:mt-10 lg:py-6 ${sectionClassName}`}
      data-testid="social-media-share-section"
      ref={impressionRef}
    >
      {(!isMobileScreen || !isServiceDetail) && (
        <p className="text-xs text-center font-bold uppercase text-reliableBlack lg:text-sm">
          Share With:
        </p>
      )}

      <div
        className={`flex items-center ${isServiceDetail ? 'w-full lg:w-fit justify-evenly lg:justify-center' : 'justify-center gap-x-5'} lg:gap-x-8`}
      >
        {filteredSocialLinks.map((platform) => (
          <a
            id={`logo-share-${platform}`}
            key={platform}
            href={enableSharing ? undefined : socialMediaShare(platform)}
            rel="noopener noreferrer"
            target="_blank"
            onClick={(e) => {
              if (isNativeView) {
                e.preventDefault();
              }
              if (promoButtonClickOption?.[platform]) {
                actionClickEmarsys(promoButtonClickOption?.[platform]);
              }
              handleClickShare(article || copyLink, platform);
            }}
            aria-label={`share ${platform} logo`}
          >
            {/* Tambahkan ikon sesuai dengan sosial media */}
            {platform === 'whatsapp' && (
              <Whatsapp className="w-[22px] h-[22px] lg:w-8 lg:h-8" fill="#231F20" />
            )}
            {platform === 'facebook' && (
              <FacebookIcon className="w-[22px] h-[22px] lg:w-8 lg:h-8" fill="#231F20" />
            )}
            {platform === 'x' && (
              <Xlogo className="w-[22px] h-[22px] lg:w-8 lg:h-8" fill="#231F20" />
            )}
            {platform === 'tiktok' && (
              <TiktokIcon className="w-[22px] h-[22px] lg:w-8 lg:h-8" fill="#231F20" />
            )}
            {platform === 'instagram' && isNativeView && (
              <InstagramIcon className="w-[22px] h-[22px] lg:w-8 lg:h-8" fill="#231F20" />
            )}
          </a>
        ))}
        <button
          id="logo-share-link"
          onClick={screenSize.mobile ? (e) => handleShare(e) : () => setShareOpen(true)}
          aria-label="share link logo button"
        >
          <PiLinkSimpleBold className="w-[22px] h-[22px] lg:w-8 lg:h-8" fill="#231F20" />
        </button>
      </div>

      {/* Share Modal */}
      {!enableSharing && shareOpen && (
        <ModalShare
          copyLink={copyLink}
          visible={true}
          article={article}
          onClose={() => setShareOpen(false)}
          link={''}
          actionClick={actionClickEmarsys}
        />
      )}
    </section>
  );
};

export default SocialMediaLinksSection;
